import React from 'react';
import { useParams } from 'react-router-dom';
import { getQuestionnaireTypeByID } from '../../utils/questionnaireTypes';
import SpiritualGiftsQuestionnaire from './SpiritualGiftsQuestionnaire';
import OrientationConscienceQuestionnaire from './OrientationConscienceQuestionnaire';

const QuestionnaireRouter = () => {
  const { id } = useParams();
  
  // Get the questionnaire type based on the ID
  const questionnaireType = getQuestionnaireTypeByID(id);
  
  if (!questionnaireType) {
    return (
      <div className="container" style={{ marginTop: '2rem' }}>
        <div className="error">
          <h2>Questionnaire introuvable</h2>
          <p>Le questionnaire demandé (ID: {id}) n'existe pas ou n'est pas disponible.</p>
        </div>
      </div>
    );
  }

  // Route to the appropriate questionnaire component based on type
  switch (questionnaireType) {
    case 'spiritual-gifts':
      return <SpiritualGiftsQuestionnaire />;
    case 'orientation-conscience':
      return <OrientationConscienceQuestionnaire />;
    default:
      return (
        <div className="container" style={{ marginTop: '2rem' }}>
          <div className="error">
            <h2>Type de questionnaire non supporté</h2>
            <p>Le type de questionnaire "{questionnaireType}" n'est pas encore implémenté.</p>
          </div>
        </div>
      );
  }
};

export default QuestionnaireRouter;